<template>
	<canvas id='contourCanvas' />
</template>


<script>
import { scaleLinear, scaleSequential } from 'd3-scale';
import { contourDensity } from 'd3-contour';
import { geoPath } from 'd3-geo';
import { extent } from 'd3-array';
import { interpolateYlOrRd } from 'd3-scale-chromatic';

import { easeQuadIn } from 'd3-ease';
import { timer } from 'd3-timer';


export default {
	props: {
		points: Array,
		config: Object,
		isPortrait: Boolean,
		screenWidth: Number,
		screenHeight: Number
	},
	data() {
		return {
			t: 0,
			xRange: [-73.981159, -73.949722],
			yRange: [40.764911, 40.800119],
			height: 0,
			width: 0,
			margin: {
				top: 20,
				right: 20,
				bottom: 20,
				left: 20
			}
		}
	},
	watch: {
		screenWidth() {
			this.resize();
		},
		screenHeight() {
			this.resize();
		},
		config() {
			this.updateCanvas();
		},
	},
	methods: {
		resize() {
			// square on landscape; cover on portrait
			const el = document.querySelector('#contourCanvas');
			const parent = document.querySelector('#contour-wrapper')
			const dims = parent.getBoundingClientRect();

			const height = dims.height
	

			// resize the canvas
			el.height = height;
			el.width = this.isPortrait ? dims.width : height;

			// store sizes for plotting
			this.height = el.height;
			this.width = el.width;
		},
		updateCanvas() {
			this.t = 0;
			if (Object.prototype.hasOwnProperty.call(this.config, 'action')) {
				this.animateContour(this.config.action, this.config.duration);
			}
		},
		animateContour(action, duration) {
			// get data
			const points = this.getPointsContour();

			const ease = easeQuadIn;
			const myTimer = timer(elapsed => {

				// compute how far through the animation we are; 0 (start) to 1 (end)
				this.t = Math.min(1, ease(elapsed / duration));
				
				// fadeIn/Out
				let opacity = 1;
				if (action === 'fadeIn') {
					opacity = this.t;
				} else {
					opacity = 1-this.t;
				}

				// update what is drawn on screen
				this.drawContour(points, opacity);

				// if this animation is over
				if (this.t === 1) {
					// stop this timer since we are done animating.
					myTimer.stop()
				}
			});
		},
		drawContour(pts, opacity) {
			// get canvas
			const canvas = document.getElementById('contourCanvas');
			const ctx = canvas.getContext('2d');

			// clear canvas
			ctx.clearRect(0, 0, this.width, this.height);

			// set path to canvas
			const path = geoPath(null, ctx);

			// draw paths
			ctx.save();
			ctx.lineWidth = 1;
			ctx.lineJoin = "round";

			pts.forEach(pt =>{ 
				const color = this.colorContour(pt.value, pts);
				// ctx.strokeStyle = color.replace(')', ',' + opacity + ')').replace('rgb', 'rgba');
				ctx.strokeStyle = 'rgba(230, 0, 0,' + .5*opacity + ')';
				ctx.fillStyle = color.replace(')', ',' + opacity + ')').replace('rgb', 'rgba');
				// ctx.fillStyle = color;	
				ctx.beginPath();
				path(pt);
				ctx.stroke();
				ctx.fill();
			})

			// draw
			ctx.restore();
		},

		getPointsContour() {
			// set up function
			let contours = contourDensity()
				.x(d => this.mapX(d.lon) )
				.y(d => this.mapY(d.lat) )
				.size([this.width, this.height])
				.bandwidth(10)
			const contourPoints = contours(this.points);
			return contourPoints
		},
		mapX(val) {
			var scale = scaleLinear()
				.domain(this.xRange)
				.range([0 + this.margin.left, this.width - this.margin.right]);
			return scale(val)
		},		
		mapY(val) {
			var scale = scaleLinear()
				.domain(this.yRange)
				.range([this.height-this.margin.bottom, 0+this.margin.top]);
			return scale(val)
		},
		colorContour(val, contours) {
			let c = scaleSequential(interpolateYlOrRd)
				.domain(extent(contours, d => d.value))
			return c(val)
		}
	}
}

</script>

<style>
</style>